import { Button } from "@/components/ui/button";

const Footer = () => {
  return (
    <footer className="bg-foreground text-background py-16 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4">
              <h2 className="text-xl font-bold text-background">
                Compare Best Behavioral EMR
              </h2>
            </div>
            <p className="text-background/80 mb-6 max-w-md">
              Your trusted resource for finding the perfect behavioral health EMR system. 
              We provide unbiased reviews and expert comparisons to help you make informed decisions.
            </p>
            <div className="flex space-x-4">
              <Button 
                variant="outline" 
                size="sm" 
                className="bg-transparent border-background/20 text-background hover:bg-background hover:text-foreground"
                onClick={() => window.location.href = '/free-guide'}
              >
                Get Free Guide
              </Button>
            </div>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm text-background/80">
              <li><a href="/comparisons" className="hover:text-background transition-colors">Comparison Tool</a></li>
              <li><a href="/resources/behavioral-health-emr-101" className="hover:text-background transition-colors">EMR 101</a></li>
              <li><a href="/resources/emr-benefits" className="hover:text-background transition-colors">EMR Benefits</a></li>
              <li><a href="/resources/how-to-choose-emr" className="hover:text-background transition-colors">Buying Guide</a></li>
              <li><a href="/resources/top-emr-solutions" className="hover:text-background transition-colors">Top Solutions</a></li>
              <li><a href="/resources/emr-implementation" className="hover:text-background transition-colors">Implementation Guide</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-sm text-background/80">
              <li><a href="/about" className="hover:text-background transition-colors">About Us</a></li>
              <li><a href="/contact" className="hover:text-background transition-colors">Contact</a></li>
              <li><a href="https://comparebestbehavioralemr.tapfiliate.com" className="hover:text-background transition-colors" target="_blank" rel="noopener noreferrer">Affiliate Program</a></li>
              <li><a href="/sitemap" className="hover:text-background transition-colors">Sitemap</a></li>
              <li><a href="/privacy" className="hover:text-background transition-colors">Privacy Policy</a></li>
              <li><a href="/terms" className="hover:text-background transition-colors">Terms of Service</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-background/20 mt-12 pt-8 text-center">
          <p className="text-background/60 text-sm">
            © 2025 Compare Best Behavioral EMR. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;